import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LinkOffIcon from "@mui/icons-material/LinkOff";

interface UnshareConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const UnshareConfirmModal: React.FC<UnshareConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Remove share</DialogTitle>
      <DialogContent>
        <Typography color="text.secondary">
          This will remove access for the selected group.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Tooltip title="Cancel">
          <IconButton
            onClick={() => {
              console.log("Canceling unshare");
              onClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Unshare">
          <IconButton
            color="error"
            onClick={() => {
              console.log("Confirming unshare");
              onConfirm();
            }}
          >
            <LinkOffIcon />
          </IconButton>
        </Tooltip>
      </DialogActions>
    </Dialog>
  );
};

export default UnshareConfirmModal;
